export const COLUMNS = [
  {
    Header: "Organization",
    accessor: "name",
    width: 240,
  },
  {
    Header: "Permissions",
    accessor: "permissions",
    width: 40,
    Cell: () =>
      'View, Edit',
  },
];
